import React from "react";

import getUmbracoEndPoint from "app/umbraco/helpers/UmbracoEndPoint";

export default async (url: string) => {
    return fetch(url, {
        method: "GET",
        headers: {
            "Accept": "image/svg+xml",
            "Content-Type": "image/svg+xml",
            "Origin": getUmbracoEndPoint(),
            "X-Request-Domain": getUmbracoEndPoint()
        },
        body: undefined
    }).then(res => res.text()).then(body => {
        const exports: any = {};

        function require(name: string) {
            if (name === "react") return React;
            else throw `You can't use modules other than "react" in remote component.`;
        }

        eval(body);

        return exports.__esModule ? exports.default : exports;
    });
};